import ActionMenu from "@/v2-backoffice-client/components/actionMenu"
import type { TenantFragment } from "@/v2-backoffice-client/tenant/__types__/tenant.fragment"
import TenantExternalToolMenuItems from "@/v2-backoffice-client/tenant/TenantExternalToolMenuItems"
import TenantMigrateMenuItem from "@/v2-backoffice-client/tenant/migration/TenantMigrateMenuItem"
import TenantUpdateMenuItem from "@/v2-backoffice-client/tenant/update/TenantUpdateMenuItem"
import TenantRemoveMenuItem from "@/v2-backoffice-client/tenant/remove/TenantRemoveMenuItem"
import TenantRestoreMenuItem from "@/v2-backoffice-client/tenant/restore/TenantRestoreMenuItem"
import TenantCustomerAddSelectorDialogMenuItem from "@/v2-backoffice-client/tenant/customer/add/TenantCustomerAddSelectorDialogMenuItem"

export type TenantTableRowToolbarProps = {
  tenant: TenantFragment
}

function TenantTableRowToolbar(props: TenantTableRowToolbarProps) {
  const { tenant } = props

  return (
    <ActionMenu>
      <ActionMenu.Trigger />

      <ActionMenu.Content>
        <TenantExternalToolMenuItems
          tenantId={tenant.Id}
          externalCustomerId={tenant.ExternalCustomerId}
          billingAccountUuid={tenant.BillingAccountUuid}
        />

        <ActionMenu.Separator />

        <TenantUpdateMenuItem tenant={tenant} />

        <TenantCustomerAddSelectorDialogMenuItem
          tenantId={tenant.Id}
          externalCustomerId={tenant.ExternalCustomerId}
        />

        {!tenant.IsDeleted && <TenantMigrateMenuItem tenant={tenant} />}

        <ActionMenu.Separator />

        {tenant.IsDeleted ? (
          <TenantRestoreMenuItem tenantId={tenant.Id} />
        ) : (
          <TenantRemoveMenuItem tenantId={tenant.Id} />
        )}
      </ActionMenu.Content>
    </ActionMenu>
  )
}

export default TenantTableRowToolbar
